import {
	styledSystem as ss,
	inputStyles,
	inputSizes,
	inputVariants,
	theme,
} from ".";

export type IInputProps = ss.ICommonProps &
	{
		block?: boolean;
		s?: "default" | "sm" | "lg" | "font";
		variant?: "contrast" | "dark" | "plain";
		withError?: boolean;
	}
;

// Basic button
export const Input = ss.styled.input<IInputProps>`
	${inputStyles}
	${props => inputSizes[props.s || "default"]}
	${props => props.block ? { width: "100%", display: "block" } : undefined }
	${props => props.variant && inputVariants[props.variant] ? inputVariants[props.variant] : undefined}
	${props => props.withError ? {borderColor: props.theme.colors.red[8]} : {}}
	${ss.COMMON}
`;

Input.defaultProps = {
	type: "text",
	theme,
}

// Variants
export const InputContrast = ss.styled(Input)``; InputContrast.defaultProps = { variant: "contrast" };
export const InputDark = ss.styled(Input)``; InputDark.defaultProps = { variant: "dark" };
export const InputPlain = ss.styled(Input)``; InputPlain.defaultProps = { variant: "plain" };
